// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"375":"2bf6b9d0","840":"2bf6b9d0"}[chunkId] + ".chunk.css";
};